import {TooltipProps} from 'recharts';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {PriceReportType} from '../../../../../types/PriceReportType';
import {StatisticsChartItem} from '../types/StatisticsChartItem';
import {CarTooltip} from './CarTooltip';

export function ChartTooltip(
  // TooltipProps comes from recharts
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: TooltipProps<any, any> & {priceReport: PriceReportType} & RequiredTestIdProps
) {
  const payload: StatisticsChartItem | Nullish = props.payload?.[0]?.payload;

  return (
    <CarTooltip
      priceReport={props.priceReport}
      car={payload?.car}
      showShadow
      data-testid={suffixTestId('carTooltip', props)}
    />
  );
}
